import type { AxiosRequestConfig } from 'axios';

import { authInstance } from '@/shared/api/api-instances/auth/api-instance';
import type {
  AuthRequest,
  MergeMethodsResponse,
  User,
} from '@/entities/user/user/@x/session';

export class AuthApi {
  static login(payload: AuthRequest, options: AxiosRequestConfig = {}) {
    return authInstance.post<User>('/login', payload, {
      timeout: 15000,
      ...options,
    });
  }

  static loginUnion(
    payload: AuthRequest,
    redirect_url?: string,
    merge_redirect_url?: string,
    state?: string,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.post<User>('/login/union', payload, {
      timeout: 15000,
      ...options,
      params: {
        redirect_url,
        merge_redirect_url,
        state: state,
      },
    });
  }

  static getMergeMethods(options: AxiosRequestConfig = {}) {
    return authInstance.get<MergeMethodsResponse>('/merge/methods', {
      timeout: 15000,
      ...options,
    });
  }

  static mergePasswordLogin(
    payload: AuthRequest,
    redirect_url?: string,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.post<User>('/merge/password/login', payload, {
      timeout: 15000,
      ...options,
      params: {
        redirect_url,
      },
    });
  }

  static mergeLdapLogin(
    payload: AuthRequest,
    redirect_url?: string,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.post<User>('/merge/ldap/login', payload, {
      timeout: 15000,
      ...options,
      params: {
        redirect_url,
      },
    });
  }

  static logout(options: AxiosRequestConfig = {}) {
    return authInstance.post('/logout', null, { timeout: 15000, ...options });
  }

  static keepAlive(options: AxiosRequestConfig = {}) {
    return authInstance.get('/keep_alive', { timeout: 15000, ...options });
  }

  static getUserInterface(options: AxiosRequestConfig = {}) {
    return authInstance.get<string[]>(`/interface/user_rules`, options);
  }
}
